export default "__VITE_ASSET__4Agk6U4B__"